import React, { useEffect } from 'react'

function TermsAndConditions(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page">
        <section
          className="hero-banner inner-banner center-bg"
          style={{ backgroundImage: `url('images/faq-banner.png')` }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="partner-banner-content">
                  <h1>
                    Terms & Conditions{' '}
                    <span style={{ color: '#42B749' }}>RoadJockey</span>
                  </h1>
                  <text>Last updated on: September 09th, 2021.</text>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1 text-left">
                <div className="faq-content">
                  <h2>I. Introduction</h2>
                  <p>
                    <strong>www.roadjockey.com (&quot;website&quot;)</strong>{' '}
                    and Mobile Application
                    <strong>&quot;ROADJOCKEY&quot;</strong> (&quot;we,&quot;
                    &quot;us,&quot; or &quot;our&quot;) welcomes you. We offer
                    you access to our services through our &quot;Website&quot;
                    and &quot;Mobile Application&quot; (defined below) subject
                    to the following Terms of this agreement, which may be
                    updated by us from time to time with or without notice to
                    you. . By accessing and using this Website and Mobile
                    Application, you acknowledge that you have read, understood
                    and agree to be lawfully bound by these Terms and Conditions
                    and our Privacy Policy, which are hereby incorporated by
                    reference (collectively, this &quot;Agreement&quot;). In
                    case you do not agree with any of these terms, then please
                    do not use the Website and Mobile Application.
                  </p>
                  <h2 className="pt-5"> II. Definations</h2>
                  <p>
                    <ul>
                      <li>
                        <strong>&quot;Agreement&quot;</strong> refers to this
                        Terms and Conditions and the Privacy Policy and other
                        documents provided to you by the Website and Mobile
                        Application;
                      </li>
                      <li>
                        <strong>&quot;Service&quot;</strong> or{' '}
                        <strong>&quot;Services&quot;</strong> refers to the
                        Services as defined below offered through the website.
                      </li>
                      <li>
                        <strong>&quot;User&quot;, &quot;You&quot;</strong> and{' '}
                        <strong>&quot;your&quot;</strong> refers to the person
                        who is accessing for taking any service of this Website
                        and Mobile Application;
                      </li>
                      <li>
                        <strong>
                          &quot;We&quot;, &quot;us&quot;, &quot;our&quot;
                        </strong>{' '}
                        are references to <strong>ROADJOCKEY LLC</strong>;{' '}
                      </li>
                      <li>
                        <strong>&quot;Website&quot;</strong> or{' '}
                        <strong>&quot;Platform&quot;</strong> shall mean and
                        include&quot;
                        <strong>https:// www.roadjockey.com</strong>, mobile
                        applications &quot;<strong>ROADJOCKEY</strong>
                        &quot; and any successor Website of the Company or any
                        of its affiliates;
                      </li>
                      <li>
                        &quot;<strong>User Account</strong>&quot; shall mean an
                        electronic account opened for the Buyer for availing
                        services offered on the website and Mobile Application;
                      </li>{' '}
                    </ul>
                  </p>
                  <h2 className="pt-5">III. Interpretation</h2>
                  <p>
                    <ul>
                      <li>
                        All references to the singular include the plural and
                        vice versa and the word &quot;includes&quot; should be
                        construed as &quot;without limitation&quot;.
                      </li>
                      <li>
                        Words importing any gender shall include all the other
                        genders.
                      </li>
                      <li>
                        Reference to any statute, ordinance, or other law
                        includes all regulations and other instruments and all
                        consolidations, amendments, re-enactments, or
                        replacements for the time being in force.
                      </li>
                      <li>
                        All headings, bold typing, and italics (if any) have
                        been inserted for convenience of reference only and do
                        not define limit, or affect the meaning or
                        interpretation of the terms of this Agreement.
                      </li>
                    </ul>
                  </p>
                  <h2 className="pt-5"> IV. Introduction and Scoope</h2>
                  <p>
                    <ul>
                      <li>
                        <strong>Scope</strong>.These Terms govern your use of
                        the Website and Mobile Application and the Services.
                        Except as otherwise specified, these Terms do not apply
                        to Third-Party Products or Services, which are governed
                        by their own terms of service.
                      </li>
                      <li>
                        <strong> Eligibility:</strong> Certain Service of the
                        Website and Mobile Application is not available to users
                        under the age of 18 or any users suspended or removed
                        from the system by us for any reason.
                      </li>
                      <li>
                        <strong> Electronic Communication:</strong>When you use
                        this Website/Mobile Application or send e-mails and
                        other electronic communications from your desktop or
                        mobile device to us, you are communicating with us
                        electronically. By sending, you agree to receive a reply
                        communications from us electronically in the same format
                        and you can keep copies of these communications for your
                        records.
                      </li>
                    </ul>
                  </p>
                  <h2 className="pt-5"> V. Services</h2>
                  <p>
                    At RoadJockey, we offer you a meticulously designed online
                    platform where we provide courier delivery service operating
                    in Jamaica.
                  </p>
                  <h2 className="pt-5"> VI. Modifications to the Services</h2>
                  <p>
                    We reserve the right, at our discretion, to change, modify,
                    add to, or remove portions of the Terms (collectively,
                    &quot;Changes&quot;), at any time. We may notify you of
                    changes by sending an email to the address identified in
                    your Account or by posting a revised version of the Terms
                    incorporating the changes to our Website and Mobile
                    Application. Your continued use of the Site following the
                    posting of changes will mean that you accept and agree to
                    the Changes.
                  </p>
                  <h2 className="pt-5"> VII. Registration</h2>
                  <p>
                    If you access this Website/ Mobile Application anonymously,
                    you will not be required to create a user name. But, to
                    access certain Resources, you may be required to provide
                    specific information and to create a user ID and password to
                    establish an account. You agree that the information you
                    provide in connection with establishing any account is
                    accurate and that you will keep your information up-to-date.
                    You are responsible for the security of all of your user
                    names, passwords, and registration information (such as
                    unique account identifiers or historical billing
                    information), and you are solely responsible for any use
                    (authorized or not) of your accounts. You agree to notify us
                    immediately about any unauthorized activity regarding any of
                    your accounts or other breaches of security. We may at our
                    discretion suspend or terminate any of your user names and
                    passwords at any time with or without notice.
                  </p>
                  <h2 className="pt-5"> VIII. User Content</h2>
                  <p>
                    A. <strong>Content Responsibility.</strong>
                  </p>
                  <p>
                    <ul>
                      <li>
                        The website/ Mobile Application permits you to submit
                        content, feedback, etc. but you are solely responsible
                        for the content submitted by you. You represent that you
                        have required permission to use the content. When
                        submitting content to the website/ Mobile Application,
                        please do not submit content that:
                      </li>
                      <li>
                        contains ill-mannered, profane, abusive, racist or
                        hateful language or expressions, text, photographs or
                        illustrations that are pornographic or in poor taste,
                        inflammatory attacks of a personal, racial or religious
                        nature;
                      </li>
                      <li>
                        is defamatory, threatening, disparaging, grossly
                        inflammatory, false, misleading, fraudulent, inaccurate,
                        unfair, contains gross exaggeration or unsubstantiated
                        claims;
                      </li>
                      <li>
                        violates the privacy rights of any third party, is
                        unreasonably harmful or offensive to any individual or
                        community;{' '}
                      </li>
                      <li>
                        discriminates on the grounds of race, religion, national
                        origin, gender, age, marital status, sexual orientation
                        or disability, or refers to such matters in any manner
                        prohibited by law;
                      </li>
                      <li>
                        violates or inappropriately encourages the violation of
                        any municipal, state, federal, or international law,
                        rule, regulation, or ordinance;
                      </li>
                      <li>
                        sends repeated messages related to another user and/or
                        makes derogatory or offensive comments about another
                        individual or repeats prior posting of the same message
                        under multiple emails or subjects.
                      </li>
                    </ul>
                    <p>
                      Any such submitted content will be refused by us. If
                      repeated violations occur, we reserve the right to cancel
                      user access tothe website and Mobile Application without
                      advanced notice.
                    </p>
                  </p>
                  <h2 className="pt-5"> IX. Prohibited Products</h2>
                  <p>
                    The following are the types of products that, for everyone’s
                    safety, you are prohibited to deliver through us: Any
                    product related to illegal activities or which is prohibited
                    by law in the place of origin, the destination, or any sites
                    through which such product travel. Any product requiring
                    specific licenses to store or distribute. Examples of
                    products with distribution and licensing requirements may
                    include, but are not limited to:
                    <ul>
                      <li>Live plants and animals;</li>
                      <li>Ammunition & firearms;</li>
                      <li>Tobacco;</li>
                      <li>Firearms and any kind of weapon;</li>{' '}
                      <li>
                        Prescription pharmaceuticals or other dangerous drugs;{' '}
                      </li>
                      <li>Explosive or hazardous products; </li>
                      <li> Counterfeit items; </li>
                      <li>Unique or one-of-a-kind materials; and </li>
                      <li>
                        {' '}
                        Precious metals in the forms of bullion or reserves.
                      </li>
                      <p>
                        We shall not be liable for any loss, damage, destruction
                        of such prohibited product. In order to maintain the
                        integrity of our Services and reputation, we will report
                        any activities pertaining to delivering prohibited items
                        to relevant law enforcement authorities and shipping
                        partners.
                      </p>
                    </ul>
                  </p>
                  <h2 className="pt-5"> X. Payment</h2>
                  <p>
                    <ul>
                      <li>
                        All the payments on this platform shall be governed by
                        our terms and conditions.
                      </li>
                      <li>
                        Payment mode shall be:
                        <ul>
                          <li>Online: Credit Cards and Debit cards; </li>
                          <li> PayPal </li>
                          <li>Other 3rd Party Payment Systems as needed</li>
                        </ul>
                      </li>
                      <li>
                        If there is an error in the order confirmation, please
                        contact us immediately by email at{' '}
                        <strong>info@roadjockey.com</strong>.
                      </li>
                      <li>
                        You must notify us instantly if any particulars are
                        inappropriate. If your payment has not been accepted you
                        will be informed of this in writing along with the
                        reasons
                      </li>
                      <li>
                        {' '}
                        We are happy to support you if there is any issue you
                        can contact our back-office team for any inquiry or
                        problem.
                      </li>{' '}
                      <li>
                        {' '}
                        A refund shall be made as per our Refund policy.
                      </li>{' '}
                      <li>
                        {' '}
                        We take customer feedback very seriously and use it to
                        constantly improve our products and quality of service.
                      </li>
                    </ul>
                  </p>
                  <h2 className="pt-5"> XI. Delivery</h2>
                  <p>
                    The Delivery person AKA &quot;ROADIE&quot; is an independent
                    entity. During any product delivery made, if the user is not
                    available in the address specified in the system, the
                    products booked by the user shall not deliver to anywhere
                    else. Within the framework of such a case, the user must
                    accept all legal responsibilities arising from booking an
                    item to an address where he/she does not exist.
                  </p>
                  <h2 className="pt-5"> XII. General Conditions</h2>
                  <p>
                    <ul>
                      <li>
                        {' '}
                        We do not guarantee the accuracy, completeness,
                        validity, or timeliness of information listed by us.{' '}
                      </li>
                      <li>
                        {' '}
                        We make material changes to these terms and conditions
                        from time to time, we may notify you either by
                        prominently posting a notice of such changes or via
                        email communication.{' '}
                      </li>
                      <li>
                        {' '}
                        The website/ Mobile Application is licensed to you on a
                        limited, non-exclusive, non-transferable,
                        non-sublicensable basis, solely to be used in connection
                        with the Service for your private, personal,
                        non-commercial use, subject to all the terms and
                        conditions of this Agreement as they apply to the
                        Service.{' '}
                      </li>
                      <li>
                        {' '}
                        We shall have no liability to you for any failure to
                        deliver Servies you have ordered or any delay in doing
                        so if caused by any event or circumstances beyond our
                        reasonable control including, without limitation,
                        adverse weather, pandemics, strikes, lockouts, and other
                        industrial disputes, breakdown or systems or network
                        access, flood, fire, explosion or accident.{' '}
                      </li>
                      <li>
                        {' '}
                        You may not make any commercial use of any of the
                        information provided on the Site or make any use of the
                        Site for the benefit of another business unless
                        explicitly permitted by www.roadjockey.com in advance.
                      </li>
                    </ul>
                  </p>
                  <h2 className="pt-5"> XIII. Limited Guarantee</h2>
                  <p>
                    By this Website/ Mobile Application:
                    <ul>
                      <li>
                        We provide an opportunity for you to avail of the
                        offered services from our Website/ Mobile Application.{' '}
                      </li>
                      <li>
                        We do not provide any warranty or guarantee that the
                        service descriptions are accurate, complete, reliable,
                        current, or error-free. If a Services offered by the
                        Website/ Mobile Application is not as described, your
                        sole remedy is to intimate us about Services for taking
                        further action.
                      </li>
                    </ul>
                  </p>
                  <h2 className="pt-5"> XIV. Geographic Restriction</h2>
                  <p>
                    We reserve the right, but not the obligation, to limit the
                    usage or supply of any service to any person, geographic
                    region, or jurisdiction. We may use this right as per the
                    necessity. We reserve the right to suspend any Service at
                    any time. Any offer to provide any Service made on this
                    Website/ Mobile Application is invalid where banned.
                  </p>
                  <h2 className="pt-5"> XV. User Responsibilities</h2>
                  <p>
                    <ul>
                      <li>
                        {' '}
                        You shall use the Service and Website/ Mobile
                        Application for a lawful purpose and comply with all the
                        applicable laws while using the Website and Mobile
                        Application;{' '}
                      </li>
                      <li>
                        {' '}
                        You shall not use or access the Website/ Mobile
                        Application for collecting any market research for some
                        competing business; •
                      </li>
                      <li>
                        You shall not misrepresent or personate any person or
                        entity for any false or illegal purpose;{' '}
                      </li>
                      <li>
                        {' '}
                        You will not use any device, scraper, or any automated
                        thing to access the Website or Mobile Application for
                        any means without taking permission.{' '}
                      </li>
                      <li>
                        {' '}
                        You will inform us about anything that is inappropriate
                        or you can inform us if you find something illegal;{' '}
                      </li>
                      <li>
                        {' '}
                        You will not interfere with or try to interrupt the
                        proper operation of the Website/ Mobile Application
                        through the use of any virus, device, information
                        collection or transmission mechanism, software or
                        routine, or access or try to gain access to any data,
                        files, or passwords connected to the Website/ Mobile
                        Application through hacking, password or data mining, or
                        any other means;{' '}
                      </li>
                      <li>
                        {' '}
                        You will not cover, obscure, block, or in any way
                        interfere with any advertisements and/or safety features
                        (e.g., report abuse button) on the Website/ Mobile
                        Application;{' '}
                      </li>
                      <li>
                        {' '}
                        You will let us know about the unsuitable content of
                        which you become aware. If you discover something that
                        infringes any law, please let us know, and we’ll review
                        it.{' '}
                      </li>
                      <li>
                        {' '}
                        You agree to comply with all applicable domestic laws,
                        statutes, ordinances, and regulations regarding your use
                        of our Website/ Mobile Application. We reserve the right
                        to investigate complaints or reported violations of our
                        Terms and to take any action we deem appropriate,
                        including but not limited to canceling your user
                        account, reporting any suspected unlawful activity to
                        law enforcement officials, regulators, or other third
                        parties
                      </li>
                    </ul>
                    <p>
                      We reserve the right, in our sole and absolute discretion,
                      to deny you access to the Website/ Mobile Application or
                      any service, or any portion of the Website/ Mobile
                      Application or service, without notice, and to remove any
                      content.
                    </p>
                  </p>
                  <h2 className="pt-5"> XVI. Exclusion of Liability</h2>
                  <p>
                    We take no responsibility for any direct or indirect damage
                    that may result from the product or service. We accept no
                    responsibility for delays/errors due to circumstances
                    outside the Company&apos;s ruling (Force Majeure).These
                    circumstances can be, for example, labor conflict, fire,
                    war, government decisions, etc. We shall not be liable and
                    responsible for the behavior of the users. And we are also
                    not accountable for the quality of the services provided by
                    the Relationship manager on the website and Mobile
                    Application. You understand and agree that we (a) do not
                    guarantee the accuracy, completeness, validity, or
                    timeliness of information listed by us or any third parties;
                    and (b) shall not be responsible for any materials posted by
                    us or any third party. You shall use your judgment, caution,
                    and common sense in evaluating any prospective methods or
                    offers and any information provided by us or any third
                    party. Further, we shall not be liable for direct, indirect
                    consequential, or any other form of loss or damage that may
                    be suffered by a user through the use of the
                    <strong>www.roadjockey.com</strong> Website and Mobile
                    Application including loss of data or information or any
                    kind of financial or physical loss or damage. In no event
                    shall RoadJockey, nor its owners, directors, employees,
                    partners, agents, suppliers, or affiliates, be accountable
                    for any indirect, incidental, special, eventful, or
                    exemplary costs, including without limitation, loss of
                    proceeds, figures, usage, goodwill, or other intangible
                    losses, consequential from (i) your use or access of or
                    failure to access or use the Service; (ii) any conduct or
                    content of any third party on the Service; and (iii)
                    unlawful access, use or alteration of your transmissions or
                    content, whether or not based on guarantee, agreement,
                    domestic wrong (including carelessness) or any other lawful
                    concept, whether or not we&apos;ve been aware of the
                    possibility of such damage.
                  </p>
                  <h2 className="pt-5"> XVII. No Responsibility</h2>
                  <p>We are not responsible to you for:</p>
                  <ul>
                    <li>
                      {' '}
                      any losses you suffer because the information you put into
                      our website and Mobile Application is inaccurate or
                      incomplete; or{' '}
                    </li>
                    <li>
                      {' '}
                      any losses you suffer because you cannot use our website
                      and Mobile Application at any time; or{' '}
                    </li>
                    <li>
                      {' '}
                      any errors in or omissions from our website or Mobile
                      Application; or{' '}
                    </li>
                    <li>
                      {' '}
                      any losses you may suffer by relying on any commentary,
                      postings, or reviews (of our services or that of our
                      partners) on our website or Mobile Application; or{' '}
                    </li>
                    <li>
                      {' '}
                      any unauthorized access or loss of personal information
                      that is beyond our control.
                    </li>
                  </ul>
                  <h2 className="pt-5"> XVIII. Release</h2>
                  <p>
                    You release us and our successors from all losses, damages,
                    rights, and demands, and actions of any kind, including
                    personal injuries, death, and property damage, that are
                    directly or indirectly related to or arising from your use
                    of the Services (collectively, &quot;Claims&quot;).
                  </p>
                  <h2 className="pt-5"> XIX. Spam Policy</h2>
                  <p>
                    You are strictly prohibited from using the Website or any of
                    our&apos;s Services for illegal spam activities, including
                    gathering email addresses and personal information from
                    others or sending any mass commercial emails.
                  </p>
                  <h2 className="pt-5"> XIX. Copyright Directive</h2>
                  <p>
                    If you have an intellectual property rights-related
                    complaint about material posted on the website, you may
                    contact our Designated Agent using the information below.
                    <strong>www.roadjockey.com</strong> ATTN: Legal Department
                    (Copyright Notification) Email:{' '}
                    <strong>info@roadjockey.com</strong> Any notice alleging
                    that materials hosted by or distributed through the website
                    infringe intellectual property rights must include the
                    following information:
                    <ul>
                      {' '}
                      <li>
                        {' '}
                        an electronic or physical signature of the person
                        authorized to act on behalf of the owner of the
                        copyright or other right being infringed;{' '}
                      </li>
                      <li>
                        {' '}
                        a description of the copyrighted work or other
                        intellectual property that you claim has been infringed;{' '}
                      </li>
                      <li>
                        {' '}
                        a description of the material that you claim is
                        infringing and where it is located on the Website;{' '}
                      </li>
                      <li>
                        {' '}
                        your address, telephone number, and email address;
                      </li>
                      <li>
                        {' '}
                        a statement by you that you have a good faith belief
                        that the use of the materials on the Website of which
                        you are complaining is not authorized by the copyright
                        owner, its agent, or the law; and{' '}
                      </li>{' '}
                      <li>
                        a statement by you that the above information in your
                        notice is accurate and that, under penalty of perjury,
                        you are the copyright or intellectual property owner or
                        authorized to act on the copyright or intellectual
                        property owner&apos;s behalf.
                      </li>
                    </ul>
                  </p>
                  <h2 className="pt-5"> XXI. Third-party Links</h2>
                  <p>
                    The Website and Mobile Application may comprise links to
                    external or third-party Websites (&quot;External
                    Sites&quot;). These links are provided exclusively as ease
                    to you and not as an authorization by us of the content on
                    such External Sites. The content of such External Sites is
                    created and used by others. You can communicate with the
                    site administrator for those External Sites. We are not
                    accountable for the content provided in the link of any
                    External Sites and do not provide any representations about
                    the content or correctness of the information on such
                    External Sites. You should take safety measures when you are
                    downloading files from all these Websites to safeguards your
                    computer from viruses and other critical programs. If you
                    agree to access linked External Sites, you do so at your own
                    risk.
                  </p>
                  <h2 className="pt-5">
                    {' '}
                    XXII. Personal Information and Privacy Policy
                  </h2>
                  <p>
                    By accessing or using this Website and Mobile Application,
                    you approve us to use, store, or otherwise process your
                    personal information as per our Privacy Policy.
                  </p>
                  <h2 className="pt-5">
                    XXIII. Errors, Inaccuracies and Omissions
                  </h2>
                  <p>
                    Every effort has been taken to ensure that the information
                    offered on this Website and Mobile Application is accurate
                    and error-free. We apologize for any errors or omissions
                    that may have occurred. We cannot give you any warranty that
                    usage of the Website or Mobile Application will be
                    error-free or fit for purpose, timely, that defects will be
                    amended, or that the site or the server that makes it
                    available are free of viruses or bugs or signifies the full
                    functionality, accuracy, reliability of the Website and
                    Mobile Application and we do not make any warranty
                    whatsoever, whether express or implied, relating to fitness
                    for purpose, or accuracy.
                  </p>
                  <h2 className="pt-5">
                    XXIV. Disclaimer of Warrantes; Limitation of Liability
                  </h2>
                  <p>
                    The Website, Mobile Application, And The Service Are
                    Provided On An &quot;As Is&quot; And &quot;As
                    Available&quot; Basis Without Any Warranties Of Any Kind,
                    Including That The Website/Mobile Application Will Operate
                    Error-Free Or That The Website/Mobile Application, Its
                    Servers Or Its Content Or Service Are Free Of Computer
                    Viruses Or Similar Contamination Or Destructive Features. We
                    Disclaim All Licenses Or Warranties, Including, But Not
                    Limited To, Licenses Or Warranties Of Title, Non-Violation
                    Of Third Parties’ Rights, And Fitness For Particular Purpose
                    And Any Warranties Arising From A Matter Of Dealing, Course
                    Of Performance, Or Usage Of Trade. In Relation With Any
                    Warranty, Contract, Or Common Law Tort Claims: (I) We Shall
                    Not Be Liable For Any Unintended, Incidental, Or Substantial
                    Damages, Lost Profits, Or Damages Resulting From Lost Data
                    Or Business Stoppage Resulting From The Use Or Inability To
                    Access And Use The Website/Mobile Application Or The
                    Content, Even If We Have Been Recommended Of The Possibility
                    Of Such Damages. The Website And Mobile Application May
                    Comprise Technical Incorrectness Or Typographical Errors Or
                    Omissions. Unless Required By Applicable Laws, We Are Not
                    Accountable For Any Such Typographical, Technical, Or
                    Pricing Errors Recorded On The Website/Mobile Application.
                    The Website/Mobile Application May Contain Information On
                    Certain Services, Not All Of Which Are Available In Every
                    Location. A Reference To A Service On The Websites And
                    Mobile Application Does Not Suggest That Such Service Is Or
                    Will Be Accessible In Your Location. We Reserve The Right To
                    Do Changes, Corrections, And/Or Improvements To The
                    Website/Mobile Application At Any Time Without Notice.
                  </p>
                  <h2 className="pt-5">XXV. Copyright and Trademark</h2>
                  <p>
                    The Website/Mobile Application contains material, such as
                    software, text, graphics, images, designs, sound recordings,
                    audiovisual works, and other material provided by or on
                    behalf of us (collectively referred to as the
                    &quot;Content&quot;). The Content may be possessed by us or
                    third parties. Unauthorized use of the Content may infringe
                    copyright, trademark, and other laws. You have no rights in
                    or to the Content, and you will not take the Content except
                    as allowed under this Agreement. No other use is allowed
                    without prior written consent from us. You must recollect
                    all copyright and other proprietary notices contained in the
                    original Content on any copy you make of the Content. You
                    may not transfer, provide license or sub-license, sell, or
                    modify the Content or reproduce, display, publicly perform,
                    make a derivative version of, distribute, or otherwise use
                    the Content in any way for any public or commercial purpose.
                    The use or posting of the Content on any other Website or in
                    a networked computer environment for any purpose is
                    expressly prohibited. If you infringe any part of this
                    Agreement, your permission to access and/or use the Content
                    and the Website/Mobile application automatically terminates
                    and you must immediately destroy any copies you have made of
                    the Content. Our trademarks, service marks, and logos used
                    and displayed on the Website/ Mobile Application are
                    registered and unregistered trademarks or service marks of
                    us. Other company, product, and service names located on the
                    Website /Mobile Application may be trademarks or service
                    marks owned by others (the &quot;Third-Party
                    Trademarks,&quot; and, collectively with us, the
                    &quot;Trademarks&quot;). Nothing on the Website/ Mobile
                    Application should be construed as granting, by implication,
                    estoppel, or otherwise, any license or right to use the
                    Trademarks, without our prior written permission specific
                    for each such use. None of the Content may be retransmitted
                    without our express, written consent for every instance.
                  </p>
                  <h2 className="pt-5">XXVI. Indemnification</h2>
                  <p>
                    You agree to defend, indemnify, and hold us and our
                    officers, directors, employees, successors, licensees, and
                    assigns harmless from and against any claims, actions, or
                    demands, including, without limitation, reasonable legal and
                    accounting fees, arising or resulting from your breach of
                    this Agreement or your misuse of the Content or the Website/
                    Mobile Application. We shall provide notice to you of any
                    such claim, suit, or proceeding and shall assist you, at
                    your expense, in defending any such claim, suit, or
                    proceeding. We reserve the right, at your expense, to assume
                    the exclusive defense and control of any matter that is
                    subject to indemnification under this section. In such case,
                    you agree to cooperate with any reasonable requests
                    assisting our defense of such matter.
                  </p>
                  <h2 className="pt-5">XXVII. Miscellaneous</h2>
                  <h4> Severability</h4>
                  <p>
                    {' '}
                    If any provision of these Terms is found to be unenforceable
                    or invalid, that provision will be limited or eliminated to
                    the minimum extent necessary so that the Terms will
                    otherwise remain in full force and effect and enforceable.
                  </p>
                  <h4>Termination</h4>
                  <strong> Term.</strong>
                  <p>
                    The Services will be provided to you can be canceled or
                    terminated by us. We may terminate these Services at any
                    time, with or without cause, upon written notice. We will
                    have no liability to you or any third party because of such
                    termination.
                  </p>{' '}
                  <strong>Effect of Termination.</strong>
                  <p>
                    Upon termination of these Terms for any reason, or
                    cancellation or expiration of your Services:(a) We will
                    cease providing the Services;(b)you will not be entitled to
                    any refunds or usage fees, or any other fees, pro-rata or
                    otherwise;(c)any fees you owe to us will immediately become
                    due and payable in full, and (d)we may delete your archived
                    data within 30 days. All sections of the Terms that
                    expressly provide for survival, or by their nature should
                    survive, will survive termination of the Terms, including,
                    without limitation, indemnification, warranty disclaimers,
                    and limitations of liability.
                  </p>
                  <h4> Entire Agreement</h4>
                  <p>
                    {' '}
                    This Agreement constitutes the entire agreement between the
                    parties hereto concerning the subject matter contained in
                    this Agreement.
                  </p>
                  <h4> Governing Law and Judicial Recourse</h4>
                  <p>
                    The terms herein will be governed by and construed under the
                    law of Jamaica without giving effect to any principles of
                    conflicts of law. The courts of Jamaica shall have exclusive
                    jurisdiction over any dispute arising from the use of the
                    Website.
                  </p>
                  <h4> Force Majeure</h4>{' '}
                  <p>
                    {' '}
                    We will have no liability to you, your users, or any third
                    party for any failure us to perform its obligations under
                    these Terms if such non-performance arises as a result of
                    the occurrence of an event beyond the reasonable control of
                    us, including, without limitation, an act of war or
                    terrorism, natural disaster, failure of electricity supply,
                    riot, civil disorder, or civil commotion or other force
                    majeure event.
                  </p>
                  <h4>Assignment</h4>
                  <p>
                    {' '}
                    We shall have the right to assign/transfer this agreement to
                    any third party including its holding, subsidiaries,
                    affiliates, associates, and group companies, without any
                    consent of the User.{' '}
                  </p>
                  <h4> Contact Information</h4>
                  <p>
                    {' '}
                    If you have any questions about these Terms, please contact
                    us at<strong>info@roadjockey.com. </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default TermsAndConditions
